import { ConnectionError, NotFoundError, ServiceUnavailableError } from '../app/errors';

export const constructEventsUrl = (day, showStarted, marketGroupId) => {
  const filters = [
    `day=${day}`,
    `showStarted=${showStarted ? 'true' : 'false'}`,
    `showInPlay=${showStarted ? 'true' : 'false'}`
  ];
  if (marketGroupId) {
    filters.push(`marketGroupId=${marketGroupId}`);
  }
  return `${api_config.betting_buddy_api}/events/football?${filters.join('&')}`;
};

export const getEvents = (day, showStarted, marketGroupId) => (
  fetch(constructEventsUrl(day, showStarted, marketGroupId), {
    method: 'GET',
    credentials: 'omit',
    cache: 'no-cache'
  })
    .catch(e => {
      throw new ConnectionError(e.message);
    })
    .then(response => {
      const { status, statusText } = response;

      switch (status) {
        case 200: {
          return response;
        }
        case 400:
        case 404: {
          throw new NotFoundError(statusText, status);
        }
        case 520: {
          throw new ServiceUnavailableError(statusText, status);
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
    .then(response => ((response.status === 200) ? response.json() : response))
);
